var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe-model",attrs:{"frameborder":"0","allow":"autoplay; fullscreen; vr","mozallowfullscreen":"true","webkitallowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }